import { render, staticRenderFns } from "./live-dianzan-canvas.vue?vue&type=template&id=c8453d50&scoped=true&"
import script from "./live-dianzan-canvas.vue?vue&type=script&lang=js&"
export * from "./live-dianzan-canvas.vue?vue&type=script&lang=js&"
import style0 from "./live-dianzan-canvas.vue?vue&type=style&index=0&id=c8453d50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8453d50",
  null
  
)

export default component.exports